import {Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren} from '@angular/core';
import {OrderOption} from '../../model/order-option';
import {ProductOrderOptionComponent} from './product-order-option/product-order-option.component';
import {DtvCatalogUtils} from '../../utils/dtv-catalog/dtv-catalog.utils';
import {TvShopEntertainmentPack} from '../../model/tv-shop-entertainment-pack';
import {OmapiIdConstants} from '../../shared/omapi-id-constants';
import {BaseActions} from '../../shared/base-actions';
import {takeUntil} from 'rxjs/operators';
import {ImageUtils} from '../../shared/utils/image/image-utils';
import {Emitter} from '../../shared/utils/emitter/emitter';
import {EmitterConstants} from '../../shared/emitter-constants';
import {Trial} from '../../model/trial';
import {PriceDetail} from '../../model/ocapi/price-detail';
import {TvShopStateService} from '../../services/state/tv-shop-state.service';

@Component({
  selector: 'app-product-detail-order-options',
  templateUrl: './product-detail-order-options.component.html',
  styleUrls: ['./product-detail-order-options.component.less']
})
export class ProductDetailOrderOptionsComponent extends BaseActions implements OnInit {

  @ViewChildren(ProductOrderOptionComponent)
  optionChildren: QueryList<ProductOrderOptionComponent>;

  @Input()
  omapiId: string;

  @Output()
  emitOrderProduct = new EventEmitter<Object>();

  @Output()
  emitOrderTrial = new EventEmitter<Object>();

  hasPackageAlready: boolean;
  isDowngrade: boolean;
  hasDaypass: boolean;
  hasTrial: boolean;
  playSportsOptions: Array<OrderOption> = [{
    name: 'play-sports',
    omapiId: OmapiIdConstants.PLAY_SPORTS,
    descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-sports',
    titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-sports',
    priceDetail: null
  }, {
    name: 'daypass',
    isDayPass: true,
    omapiId: OmapiIdConstants.DAY_PASS,
    descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-day-pass',
    titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-day-pass',
    priceDetail: null
  }, {
    name: 'trial-box',
    isTrial: true,
    omapiId: OmapiIdConstants.TRIALS,
    descriptionKey: 'eos-tv-shop-ii.text.play-sports-details-order-options-trial-box',
    titleKey: 'eos-tv-shop-ii.title.play-sports-details-order-options-trial-box',
    priceDetail: null
  }
  ];

  constructor(private stateService: TvShopStateService) {
    super();
  }

  ngOnInit() {
    this.subscribeToTrialActivation();
    const packs = this.stateService.selectSnapshot(state => state.tvShopEntertainmentPacks);
    const pack = DtvCatalogUtils.getTvShopEntertainmentPackForOmapiId(packs, this.omapiId);
    this.enrichPlaySportsOptions(pack);
    this.processOverlay(pack);
    const price = DtvCatalogUtils.getPriceForProduct(packs, OmapiIdConstants.DAY_PASS);
    this.enrichPlaySportDaypassOption(price);
  }

  private subscribeToTrialActivation() {
    Emitter.of(EmitterConstants.OPEN_TRIAL_SUCCESS_MODAL)
      .pipe(takeUntil(this.stopSubscription)).subscribe((trial: Trial) => {
      if (trial.omapiId === OmapiIdConstants.PLAY_SPORTS_TRIAL) {
        this.hasTrial = true;
      }
    });
  }

  private processOverlay(pack: TvShopEntertainmentPack): void {
    this.playSportsOptions.forEach(option => option.showPrices = this.shouldShowPrices(pack, option));
    this.isDowngrade = pack.isDowngrade;
    this.hasPackageAlready = pack.subscribed;
    this.hasDaypass = pack.hasDayPass;
    this.hasTrial = pack.hasTrial;
  }

  private shouldShowPrices(pack: TvShopEntertainmentPack, option) {
    return !pack.isDowngrade && !pack.subscribed && !(option.omapiId !== OmapiIdConstants.PLAY_SPORTS && (pack.hasDayPass || pack.hasTrial));
  }

  private enrichPlaySportsOptions(pack: TvShopEntertainmentPack): void {
    this.playSportsOptions.filter(option => option.omapiId === pack.omapiId).forEach(option => {
      option.pack = pack;
      option.priceDetail = pack.priceDetail;
      option.isUpgrade = pack.isUpgrade;
    });
  }

  private enrichPlaySportDaypassOption(price: PriceDetail): void {
    this.playSportsOptions.filter(option => option.omapiId === OmapiIdConstants.DAY_PASS).forEach(option => {
      option.pack = new TvShopEntertainmentPack();
      option.pack.omapiId = OmapiIdConstants.DAY_PASS;
      option.pack.isDowngrade = false;
      option.priceDetail = price;
      option.pack.isDayPass = true;
    });
  }

  public get backgroundImageUrl(): string {
    return ImageUtils.getBackgroundImageUrl(this.omapiId, 'order');
  }

  public isPlaySports(): boolean {
    return this.omapiId === OmapiIdConstants.PLAY_SPORTS;
  }

  public onEmitOrderProduct(event): void {
    this.emitOrderProduct.emit(event);
  }

  public onEmitOrderTrial(event): void {
    this.emitOrderTrial.emit(event);
  }

  public get showOverlay(): boolean {
    return this.hasPackageAlready || this.isDowngrade || this.hasDaypass || this.hasTrial;
  }
}
